import React from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import PublicNavbar from '../components/PublicNavbar';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-purple-50 flex flex-col">
      <PublicNavbar />

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12 flex-1">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Use</h1>
          <p className="text-gray-500 mb-8">Last updated: December 24, 2025</p>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing or using SmartDaddy AI, you agree to be bound by these Terms of Use. 
              If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Description of Service</h2>
            <p className="text-gray-600 mb-6">
              SmartDaddy AI is a family activity management platform that helps parents organize 
              and track their children's sports, activities, and events. Our AI-powered features 
              provide summaries and insights to simplify family scheduling.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. User Accounts</h2>
            <p className="text-gray-600 mb-4">
              To use SmartDaddy AI, you must:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>Be at least 18 years old or have parental consent</li>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Acceptable Use</h2>
            <p className="text-gray-600 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
              <li>Use the service for any unlawful purpose</li>
              <li>Share your account with others</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Upload malicious content or interfere with the service</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              SmartDaddy AI and its original content, features, and functionality are owned by 
              SmartDaddy AI and are protected by international copyright, trademark, and other 
              intellectual property laws.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              SmartDaddy AI shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages resulting from your use of the service. We provide the service 
              "as is" without warranties of any kind.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Changes to Terms</h2>
            <p className="text-gray-600 mb-6">
              We reserve the right to modify these terms at any time. We will notify users of 
              significant changes via email or through the service. Continued use after changes 
              constitutes acceptance of the new terms.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Contact</h2>
            <p className="text-gray-600">
              For questions about these Terms,{' '}
              <Link to="/contact" className="text-blue-500 hover:underline">contact us</Link>.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-100 py-6">
        <div className="max-w-6xl mx-auto px-4 flex flex-wrap justify-between items-center">
          <p className="text-xs text-gray-400">
            © 2025 SmartDaddy AI. All rights reserved. | An{' '}
            <a href="https://offworldventures.org" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600">
              OffWorld Ventures
            </a>{' '}
            company.
          </p>
          <div className="flex gap-6 text-xs text-gray-400">
            <Link to="/privacy" className="hover:text-gray-600">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-600 font-medium text-gray-600">Terms of Use</Link>
            <Link to="/contact" className="hover:text-gray-600">Contact Us</Link>
            <Link to="/pricing" className="hover:text-gray-600">Pricing</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
